import { Component, OnDestroy, OnInit } from '@angular/core';
import { LayoutService } from '../../../core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { AppPageService } from 'src/app/features/modules/page/services';
import { map } from 'rxjs/operators';
import { StaticPageModel, StaticPagePositionEnum } from 'src/app/features/modules/page/models';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
})
export class HeaderMenuComponent implements OnInit, OnDestroy {
  ulCSSClasses: string;
  subscriptions: Subscription[] = [];
  url: string;
  headerPages: StaticPageModel[] = [];

  constructor(
    private layout: LayoutService,
    private oAuthService: OAuthService,
    private appPageService: AppPageService,
    private router: Router
  ) {
    this.subscriptions.push(
      router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.url = event.url;
        }
      })
    );
  }

  ngOnInit(): void {
    this.url = this.router.url;
    this.ulCSSClasses = this.layout.getStringCSSClasses('header_menu_nav');
    this._fetchHeaderLinks();
    this._listenToPagesChanges();
  }

  get isUserLoggedIn(): boolean {
    return this.oAuthService.hasValidAccessToken();
  }

  isInHomeArea(): boolean {
    return this.url === '/';
  }

  isInPracticeArea(): boolean {
    return this.url.startsWith('/problem');
  }

  isInContestArea(): boolean {
    return this.url.startsWith('/contest');
  }

  isInGeneralLeadboardArea(): boolean {
    return this.url.startsWith('/leaderboard');
  }

  isInTrainingArea(): boolean {
    return this.url.startsWith('/training');
  }

  navigateToContestList(path: string): void {
    this.router.navigateByUrl(path);
    const kt_header_menu_wrapper = document.getElementById('kt_header_menu_wrapper');
    if (kt_header_menu_wrapper) {
      kt_header_menu_wrapper.classList.remove('header-menu-wrapper-on');
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  private _fetchHeaderLinks(): void {
    this.appPageService.getAllPages().subscribe();
  }

  private _listenToPagesChanges(): void {
    this.appPageService.customPages$
      .pipe(
        map((pages: StaticPageModel[]) =>
          pages.filter(x => x.positionType === StaticPagePositionEnum.Header)
        )
      )
      .subscribe(pages => {
        if (pages && this.headerPages.length === 0) {
          this.headerPages = pages;
        }
      });
  }
}
